module.exports = __webpack_public_path__ + "static/media/TS.51c55f09.svg";